import VerticalStepProgressBar from './VerticalStepProgressBarContainer';

export default VerticalStepProgressBar;



// WEBPACK FOOTER //
// ./src/components/molecules/VerticalStepProgressBar/index.js